import { FacetToken } from "../types/facets";
import FacetInput from "./FacetInput";

interface FilterBarProps {
  tokens: FacetToken[];
  onTokensChange: (tokens: FacetToken[]) => void;
}

const FilterBar = ({ tokens, onTokensChange }: FilterBarProps) => {
  return (
    <div className="filter-bar">
      <label className="filter-label" htmlFor="feed-filter-input">
        Filter feed
      </label>
      <FacetInput value={tokens} onChange={onTokensChange} onClear={() => onTokensChange([])} />
    </div>
  );
};

export default FilterBar;
